// @flow
import { Map, fromJS } from 'immutable';
import type { List } from 'immutable';

type OperationEntry = {
	operation: string,
	targetType: string,
};

export const operationsTransformer = (
	operations: Array<OperationEntry>,
): Map<string, List<string>> => {
	const operationsObj = operations.reduce((transformedOperations, entry) => {
		const { operation } = entry;
		const { targetType } = entry;

		if (!transformedOperations[operation]) {
			transformedOperations[operation] = [];
		}

		transformedOperations[operation].push(targetType);

		return transformedOperations;
	}, {});

	return Map(fromJS(operationsObj));
};
